import { actionNameGenerator } from "../../utils/commonUtil";

const domainPrefix = "car";
const carActionNameGenerator = actionNameGenerator(domainPrefix);

export const carouselDataType = carActionNameGenerator("carouselData");
export const carouselDataSuccessType = carActionNameGenerator("carouselDataSuccess");
export const carouselDataFailedType = carActionNameGenerator("carouselDataFailed");
export const carouselDataLoaderType = carActionNameGenerator("carouselDataLoader");

